import React, { Fragment } from "react";

const AdressOne = () => {
  return (
    <Fragment>
      <div className="address-block-one d-flex border-right">
        <div className="icon">
          <img src="images/icon/icon_06.svg" alt="" />
        </div>
        <div className="text-meta">
          <h4 className="title">Our Address</h4>
          <p>
            HQ NoteG Technologies C-922, Tower C, iThum Business Park Sector-
            {/* <br /> */}
            62, Electronic City, Noida, Uttar Pradesh 201309
          </p>
        </div>
        {/* /.text-meta */}
      </div>
      {/* /.address-block-one */}
    </Fragment>
  );
};

export default AdressOne;
